// Import photos for Beauvezer-Champautric terrain
import beauvezer1 from './assets/beauvezer-champautric/07ff856d-49f7-4167-85b6-2c71fea4d52d.jpg';
import beauvezer2 from './assets/beauvezer-champautric/0d7da152-46ad-4c7f-953e-eff249b8fe40.jpg';
import beauvezer3 from './assets/beauvezer-champautric/16cfd569-fe55-49fd-963e-6cdcc412d9b0.jpg';
import beauvezer4 from './assets/beauvezer-champautric/17e8ec3b-416e-4422-a513-86a66cc1e700.jpg';
import beauvezer5 from './assets/beauvezer-champautric/3b2051f2-580a-4665-80c8-282df64562fd.jpg';
import beauvezer6 from './assets/beauvezer-champautric/4fba1115-8897-42b9-833e-387928c9e9df.jpg';
import beauvezer7 from './assets/beauvezer-champautric/7bf6f3ef-6f43-4f23-a04a-057dc59a83ec.jpg';
import beauvezer8 from './assets/beauvezer-champautric/7d918689-2927-47ba-b3df-f8ddc83bdf5e.jpg';
import beauvezer9 from './assets/beauvezer-champautric/8a2c47d4-be4a-446a-8182-e3c4fe933d21.jpg';
import beauvezer10 from './assets/beauvezer-champautric/928bd067-0d50-488e-acfb-0dccd9a30332.jpg';
import beauvezer11 from './assets/beauvezer-champautric/cb7ffb9d-3b3a-4116-b186-c903b4bf15f0.jpg';
import beauvezer12 from './assets/beauvezer-champautric/e07733c6-1805-4953-bc04-5353c1935db7.jpg';
import beauvezer13 from './assets/beauvezer-champautric/f3d4ae49-832c-4919-a5f1-eab009cc0f4b.jpg';

// Import photos for Colmars-Espiniers construction project
import colmars1 from './assets/colmars-espiniers/Image-JPEG-426B-8B57-46-0.jpg';
import colmars2 from './assets/colmars-espiniers/Image-JPEG-47BF-9F74-90-1.jpg';
import colmars3 from './assets/colmars-espiniers/Image-JPEG-4965-80AB-E4-0.jpg';
import colmars4 from './assets/colmars-espiniers/Image-JPEG-4988-B30A-32-0.jpg';
import colmars5 from './assets/colmars-espiniers/Image-JPEG-4A5C-9826-EE-0.jpg';
import colmars6 from './assets/colmars-espiniers/Image-JPEG-4AB5-A957-7E-0.jpg';
// PDF file is in public folder for direct access
const colmarsPdf = '/colmars-espiniers-projet.pdf';

export const terrainListings = [
  {
    id: 25,
    title: "Terrain à Beauvezer — Champautric Bas",
    subtitle: "Au cœur de la vallée du Haut Verdon, Alpes-de-Haute-Provence",
    price: 0, // Цена будет указана позже или можно оставить 0 для "Sur demande"
    location: "Beauvezer",
    fullAddress: "115 Impasse Champautric Bas, 04370 Beauvezer, France",
    hameau: "Champautric",
    commune: "Beauvezer",
    department: "Alpes-de-Haute-Provence (04)",
    region: "Provence-Alpes-Côte d'Azur",
    surface: 0, // Площадь будет указана позже
    altitude: 1150,
    image: beauvezer1,
    coordinates: { lat: 44.146, lng: 6.58342 },
    gallery: [
      beauvezer1,
      beauvezer2,
      beauvezer3,
      beauvezer4,
      beauvezer5,
      beauvezer6,
      beauvezer7,
      beauvezer8,
      beauvezer9,
      beauvezer10,
      beauvezer11,
      beauvezer12,
      beauvezer13
    ],
    description: `Projet de lotissement « Champautric » à Beauvezer, au cœur de la vallée du Haut Verdon, à 1 150 mètres d'altitude. Ensemble résidentiel de standing composé de 6 lots individuels destinés à la construction de chalets ou maisons de montagne, offrant un cadre de vie d'exception entre forêts et sommets.`,
    longDescription: `Projet de lotissement — Champautric, Beauvezer

Au cœur de la vallée du Haut Verdon, à 1 150 mètres d'altitude, le projet de lotissement « Champautric » prévoit la création d'un ensemble résidentiel de standing composé de 6 lots individuels destinés à la construction de chalets ou maisons de montagne.

Implanté sur un terrain préservé, entre forêts et sommets, ce programme offre un cadre de vie d'exception : calme absolu, air pur et panoramas remarquables sur les montagnes environnantes. Chaque lot est pensé pour s'intégrer harmonieusement dans le paysage naturel, avec des surfaces généreuses et un accès optimisé.

Points clés du projet :

- 6 lots viabilisés prêts à construire
- Superficie des lots adaptée à des constructions individuelles spacieuses
- Environnement naturel préservé à proximité des stations de ski et des sentiers de randonnée
- Réseaux et accès routiers prévus dans le plan d'aménagement
- Projet conçu dans le respect des normes environnementales et architecturales locales

Ce lotissement représente une opportunité rare pour les acquéreurs recherchant un investissement immobilier en montagne, alliant qualité de vie, authenticité et valorisation patrimoniale.`,
    nearbyPoints: [
      { name: "Village de Beauvezer (centre)", distance: "~2 km" },
      { name: "Colmars-les-Alpes (cité Vauban)", distance: "~5 km" },
      { name: "Villars-Colmars", distance: "~3 km" },
      { name: "Station Le Seignus (ski)", distance: "~15 km" },
      { name: "Station La Foux d'Allos (ski)", distance: "~20 km" },
      { name: "Lac d'Allos", distance: "~25 km" },
      { name: "Gorges de Saint-Pierre", distance: "~3 km" },
      { name: "Parc National du Mercantour", distance: "~15 km" },
      { name: "Saint-André-les-Alpes (Lac de Castillon)", distance: "~25 km" }
    ],
    features: {
      constructible: true,
      orientation: "Variable selon emplacement",
      access: "Route goudronnée",
      viabilisation: "À prévoir",
      electricity: "Disponible",
      shape: "À définir selon parcelle"
    },
    status: "available"
  },
  {
    id: 1,
    title: "Terrain à Seyssuel 921M²",
    price: 179000,
    location: "Seyssuel",
    surface: 921,
    image: "https://images.unsplash.com/photo-1587745890135-20db8c79b027?w=800",
    coordinates: { lat: 45.5667, lng: 4.8333 }
  },
  {
    id: 2,
    title: "Terrain à Le Grand Lemps 561 m2",
    price: 69000,
    location: "Le Grand-Lemps",
    surface: 561,
    image: "https://images.unsplash.com/photo-1465541064977-5a2d76b09f1f?w=800",
    coordinates: { lat: 45.3833, lng: 5.4167 }
  },
  {
    id: 3,
    title: "Terrain à Vienne 513 m²",
    price: 149000,
    location: "Vienne",
    surface: 513,
    image: "https://images.unsplash.com/photo-1506695041619-5dd4f46960b7?w=800",
    coordinates: { lat: 45.5256, lng: 4.8739 }
  },
  {
    id: 4,
    title: "Terrain à LORIOL 425 m²",
    price: 83000,
    location: "Loriol-sur-Drôme",
    surface: 424,
    image: "https://images.unsplash.com/photo-1653663786108-21ca52a24171?w=800",
    coordinates: { lat: 44.7569, lng: 4.8281 }
  },
  {
    id: 5,
    title: "Terrain à CHARMES SUR L'HERBASSE 500 m²",
    price: 79500,
    location: "Charmes-sur-l'Herbasse",
    surface: 500,
    image: "https://images.unsplash.com/photos/27062931/pexels-photo-27062931.jpeg?w=800",
    coordinates: { lat: 45.1333, lng: 4.9667 }
  },
  {
    id: 6,
    title: "Terrain à SAINT PRIM 915 m²",
    price: 132000,
    location: "Saint-Prim",
    surface: 915,
    image: "https://images.unsplash.com/photos/7937765/pexels-photo-7937765.jpeg?w=800",
    coordinates: { lat: 45.4667, lng: 4.8333 }
  },
  {
    id: 7,
    title: "Terrain à VALENCE 618 m²",
    price: 175000,
    location: "Valence",
    surface: 618,
    image: "https://images.unsplash.com/photo-1761479559791-58f4050895fc?w=800",
    coordinates: { lat: 44.9333, lng: 4.8917 }
  },
  {
    id: 8,
    title: "Terrain VALENCE 349 m²",
    price: 107000,
    location: "Valence",
    surface: 349,
    image: "https://images.unsplash.com/photo-1761024404773-ff65cf5aefa8?w=800",
    coordinates: { lat: 44.9333, lng: 4.8917 }
  },
  {
    id: 9,
    title: "Terrain à CHABEUIL 625 m²",
    price: 181900,
    location: "Chabeuil",
    surface: 625,
    image: "https://images.unsplash.com/photos/6788326/pexels-photo-6788326.jpeg?w=800",
    coordinates: { lat: 44.9, lng: 5.0167 }
  },
  {
    id: 10,
    title: "Terrain à GRANGES LES BEAUMONT 425 m²",
    price: 92818,
    location: "Granges-les-Beaumont",
    surface: 425,
    image: "https://images.unsplash.com/photos/95687/pexels-photo-95687.jpeg?w=800",
    coordinates: { lat: 44.9667, lng: 4.9667 }
  },
  {
    id: 11,
    title: "Terrain à La Rivière 636m²",
    price: 120000,
    location: "La Riviere",
    surface: 636,
    image: "https://images.unsplash.com/photo-1717523084968-4c15265de47a?w=800",
    coordinates: { lat: 45.3667, lng: 5.4833 }
  },
  {
    id: 12,
    title: "Terrain à St Romans 547 m²",
    price: 89000,
    location: "Saint-Romans",
    surface: 547,
    image: "https://images.unsplash.com/photo-1574980362852-67795d06a31b?w=800",
    coordinates: { lat: 45.1167, lng: 5.1333 }
  },
  {
    id: 13,
    title: "Terrain à St Sauveur 501 m²",
    price: 89000,
    location: "Saint-Sauveur",
    surface: 501,
    image: "https://images.unsplash.com/photos/552785/pexels-photo-552785.jpeg?w=800",
    coordinates: { lat: 45.3667, lng: 5.5167 }
  },
  {
    id: 14,
    title: "Terrain à Vienne 38200 – 513 m²",
    price: 149000,
    location: "Vienne",
    surface: 513,
    image: "https://images.unsplash.com/photos/762064/pexels-photo-762064.jpeg?w=800",
    coordinates: { lat: 45.5256, lng: 4.8739 }
  },
  {
    id: 15,
    title: "Terrain à Varces-Allières-et-Risset 380 m²",
    price: 140000,
    location: "Varces-Allières-et-Risset",
    surface: 380,
    image: "https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=800",
    coordinates: { lat: 45.0833, lng: 5.6667 }
  },
  {
    id: 16,
    title: "Terrain à Pont-Evêque 460m²",
    price: 124900,
    location: "Pont-Évêque",
    surface: 460,
    image: "https://images.unsplash.com/photo-1587745890135-20db8c79b027?w=800",
    coordinates: { lat: 45.5333, lng: 4.9 }
  },
  {
    id: 17,
    title: "Terrain à St Sauveur 501 m² + projet de construction",
    price: 244000,
    location: "Saint-Sauveur",
    surface: 501,
    image: "https://images.unsplash.com/photo-1465541064977-5a2d76b09f1f?w=800",
    coordinates: { lat: 45.3667, lng: 5.5167 }
  },
  {
    id: 18,
    title: "Terrain à Saint Romans 547 m² + projet de construction",
    price: 236000,
    location: "Saint-Romans",
    surface: 547,
    image: "https://images.unsplash.com/photo-1506695041619-5dd4f46960b7?w=800",
    coordinates: { lat: 45.1167, lng: 5.1333 }
  },
  {
    id: 19,
    title: "Terrain à Saint Jean de Bournay 686m2",
    price: 95000,
    location: "Saint-Jean-de-Bournay",
    surface: 686,
    image: "https://images.unsplash.com/photo-1653663786108-21ca52a24171?w=800",
    coordinates: { lat: 45.5022, lng: 5.1396 }
  },
  {
    id: 20,
    title: "Terrain viabilisé à Roussillon 402m2 + Projet de construction",
    price: 249500,
    location: "Roussillon",
    surface: 402,
    image: "https://images.unsplash.com/photos/27062931/pexels-photo-27062931.jpeg?w=800",
    coordinates: { lat: 45.3943, lng: 4.8069 }
  },
  {
    id: 21,
    title: "Terrain à Auberives sur Varèze 606m2 + Projet de construction",
    price: 239600,
    location: "Auberives-sur-Varèze",
    surface: 606,
    image: "https://images.unsplash.com/photos/7937765/pexels-photo-7937765.jpeg?w=800",
    coordinates: { lat: 45.4167, lng: 4.8 }
  },
  {
    id: 22,
    title: "Terrain à Saint Prim 565m2 + Projet de construction",
    price: 320000,
    location: "Saint-Prim",
    surface: 565,
    image: "https://images.unsplash.com/photo-1761479559791-58f4050895fc?w=800",
    coordinates: { lat: 45.4667, lng: 4.8333 }
  },
  {
    id: 23,
    title: "Terrain à Sablons 427m2 + Projet de construction",
    price: 248500,
    location: "Sablons",
    surface: 427,
    image: "https://images.unsplash.com/photo-1761024404773-ff65cf5aefa8?w=800",
    coordinates: { lat: 45.3167, lng: 4.7667 }
  },
  {
    id: 24,
    title: "Terrain à Davézieux 554m2 + Projet de construction",
    price: 255500,
    location: "Davézieux",
    surface: 554,
    image: "https://images.unsplash.com/photos/6788326/pexels-photo-6788326.jpeg?w=800",
    coordinates: { lat: 45.2597, lng: 4.6956 }
  }
];

export const agencies = [
  {
    id: 1,
    name: "MRTP SARL - Atelier principal",
    address: "5 Lot. Côte Meunière",
    postalCode: "04370",
    city: "Villars-Colmars",
    phone: "04 92 00 00 00",
    email: "Contact@artduchalet.com",
    mapUrl: "https://www.google.com/maps/place/5+Lot.+C%C3%B4te+Meuni%C3%A8re,+04370+Villars-Colmars,+France"
  }
];

export const houseModels = [
  { id: 'mc72', name: 'MC72', title: 'Maison plain-pied MC72', type: 'Plain-pied', style: 'Traditionnelle', image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800' },
  { id: 'mc88', name: 'MC88', title: 'Maison Etage MC88', type: 'Étage', style: 'Moderne', image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800' },
  { id: 'mce1', name: 'MCE 1', title: 'Maison plain-pied MCE1', type: 'Plain-pied', style: 'Moderne', image: 'https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?w=800' },
  { id: 'mce2', name: 'MCE 2', title: 'Maison Etage MCE 2', type: 'Étage', style: 'Provençale', image: 'https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?w=800' },
  { id: 'mc1', name: 'MC1', title: 'Maison plain-pied MC1', type: 'Plain-pied', style: 'Moderne', image: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?w=800' },
  { id: 'mc2', name: 'MC2', title: 'Maison plain-pied MC2', type: 'Plain-pied', style: 'Moderne', image: 'https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg?w=800' },
  { id: 'mc16', name: 'MC16', title: 'Maison plain-pied en L MC16', type: 'Plain-pied', style: 'Moderne', image: 'https://images.unsplash.com/photo-1659720879195-d5a108231648?w=800' },
  { id: 'mc20', name: 'MC20', title: 'Maison demi-niveau MC20', type: 'Demi-niveau', style: 'Moderne', image: 'https://images.unsplash.com/photo-1659720879386-923f2a19f19e?w=800' },
  { id: 'mc40', name: 'MC40', title: 'Maison à Etage MC40', type: 'Étage', style: 'Contemporaine', image: 'https://images.unsplash.com/photo-1659720879327-827462ca3942?w=800' }
];

export const constructionProjects = [
  {
    id: 'colmars-espiniers',
    title: 'Maison Ossature Bois — Colmars-les-Alpes',
    subtitle: 'Construction neuve au cœur de la cité fortifiée du Haut Verdon',
    location: 'Colmars-les-Alpes',
    fullAddress: '646 Chemin des Espiniers, 04370 Colmars, France',
    commune: 'Colmars-les-Alpes',
    department: 'Alpes-de-Haute-Provence (04)',
    region: "Provence-Alpes-Côte d'Azur",
    altitude: 1175,
    coordinates: { lat: 44.1806, lng: 6.6264 }, // Approximate coordinates for Colmars-les-Alpes
    projectType: 'Construction de maison à ossature bois',
    status: 'En cours de construction',
    image: colmars1,
    pdfFile: colmarsPdf,
    gallery: [
      colmars1,
      colmars2,
      colmars3,
      colmars4,
      colmars5,
      colmars6
    ],
    description: `Au cœur de la haute vallée du Verdon, à Colmars-les-Alpes — village classé « Plus Beaux Villages de France » depuis 2025 —, MRTP SARL réalise la construction d'une maison contemporaine à ossature bois. Ce projet allie performance énergétique et intégration harmonieuse dans un environnement montagnard d'exception.`,
    longDescription: `Au cœur de la haute vallée du Verdon, à Colmars-les-Alpes — village classé « Plus Beaux Villages de France » depuis 2025 —, MRTP SARL réalise la construction d'une maison contemporaine à ossature bois.

Ce projet allie performance énergétique et intégration harmonieuse dans un environnement montagnard d'exception. La maison, implantée au 646 Chemin des Espiniers, bénéficie d'un cadre naturel remarquable aux portes du Parc National du Mercantour.

**Une conception bioclimatique et performante**

La maison est construite en ossature bois de haute qualité (bois C24 séché techniquement), avec une isolation renforcée de 210 mm en murs et 250 mm en toiture (laine de roche minérale). L'ensemble garantit un confort thermique optimal en toutes saisons — indispensable à 1 175 mètres d'altitude — tout en respectant les normes environnementales les plus exigeantes.

**Des espaces de vie pensés pour le confort**

Répartie sur deux niveaux, la maison offre environ 103 m² de surface utilisable. Le rez-de-chaussée s'articule autour d'une généreuse pièce de vie ouverte sur la cuisine (33 m²), complétée par une chambre avec salle de bains et dressing. L'étage accueille une seconde chambre, une salle de bains et une vaste mezzanine de près de 19 m², idéale comme espace bureau, bibliothèque ou coin détente avec vue sur les sommets.`,
    surfaces: {
      sol: 105.65,
      utilisable: 103.40,
      totale: 113.50,
      construction: 98.70
    },
    floors: {
      rdc: {
        name: 'Rez-de-chaussée',
        rooms: [
          { name: 'Pièce de vie / Cuisine', surface: 33.10 },
          { name: 'Chambre', surface: 9.30 },
          { name: 'Salle de bains / Dressing', surface: 5.70 },
          { name: 'Cave', surface: null },
          { name: 'WC', surface: null },
          { name: 'Local vélo / moto', surface: 4.90 }
        ]
      },
      r1: {
        name: 'Étage (R+1)',
        rooms: [
          { name: 'Chambre', surface: 12.70 },
          { name: 'Salle de bains / Dressing', surface: 4.70 },
          { name: 'Mezzanine', surface: 18.70 }
        ]
      }
    },
    technicalSpecs: {
      structure: 'Ossature bois, classe C24, bois séché techniquement',
      isolationMurs: '210 mm (laine de roche Isover POLTERM 35 kg/m³ + panneau NaturHeld WAND 180 coupe-vent 60 mm)',
      isolationToiture: '250 mm (laine de roche Isover POLTERM 35 kg/m³)',
      pareVapeur: 'Membrane Corotop Active Control 100 g/m²',
      protectionVentHumidite: 'Membrane COROTOP BLUE 140 g/m²',
      contreventement: 'Panneaux OSB 12 mm',
      poutreFaitiere: 'BSH 140×520 mm',
      garantie: '5 ans sur les matériaux et les travaux'
    },
    nearbyPoints: [
      { name: 'Village de Colmars-les-Alpes (centre)', distance: '~500 m' },
      { name: 'Beauvezer', distance: '~5 km' },
      { name: 'Villars-Colmars', distance: '~3 km' },
      { name: 'Station Le Seignus (ski)', distance: '~12 km' },
      { name: "Station La Foux d'Allos (ski)", distance: '~18 km' },
      { name: "Lac d'Allos", distance: '~20 km' },
      { name: 'Parc National du Mercantour', distance: '~10 km' }
    ]
  }
];